/** @format */

import React from "react";
import PlayStore from "../../assets/Playstoresmall.svg";
import AppleStore from "../../assets/Applestoresmall.svg";

const FooterBottom = () => {
  return (
    <div className="border-t border-white">
      <div className="flex md:flex-row flex-col justify-between xl:px-24 px-8 items-center py-[22px]">
        <h5 className="font-semibold md:text-[18px] text-[14px] leading-[27.28px] text-white">
          © 2022 Fit-stats.com . All rights reserved
        </h5>
        <div className="flex space-x-8 md:mt-0 mt-4">
          <img src={PlayStore} alt="PlayStore" className="cursor-pointer" />
          <img src={AppleStore} alt="AppleStore" className="cursor-pointer" />
        </div>
      </div>
    </div>
  );
};

export default FooterBottom;
